<template>
  <AutoCompleteInput
    v-model="values_clone.selected_delay_duration"
    class="mt-4"
    :show-down-icon="true"
    :show-plus-btn="false"
    :icon="null"
    value-attr="value"
    label-attr="label"
    :placeholder="$t('Delay duration')"
    :data="delay_durations"
    :value="values_clone.selected_delay_duration"
    @chosen="
      ($event) => {
        values_clone.selected_delay_duration = $event.value
      }
    "
    @reset="values_clone.selected_delay_duration = null" />

  <div class="flex w-full mt-4 ml-auto rounded-md shadow-sm">
    <div class="relative flex items-stretch flex-grow focus-within:z-10">
      <div class="absolute inset-y-0 z-50 flex items-center pl-3 pointer-events-none right-2 text-common-grey">
        {{ values_clone.selected_delay_duration }}
      </div>
      <TextInput
        :value="values_clone.selected_duration_value"
        input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
        name="goal_name"
        :min-value="1"
        type="number"
        :validate-on-input="true"
        :label="$t('Enter value')"
        :placeholder="$t('Enter value')"
        @update:modelValue="
          (e) => {
            values_clone.selected_duration_value = e
          }
        " />
    </div>
  </div>
</template>

<script>
import AutoCompleteInput from "@/components/shared/AutoCompleteInput.vue"
import TextInput from "@/components/shared/TextInput.vue"

export default {
  components: { AutoCompleteInput, TextInput },
  props: { selectedNode: null },
  emits: ["updateValues"],

  data() {
    return {
      values_clone: { selected_delay_duration: null, selected_duration_value: null, duration: null }
    }
  },
  computed: {
    delay_durations() {
      return [
        { value: "seconds", label: this.$t("Seconds") },
        { value: "minutes", label: this.$t("Minutes") },
        { value: "hours", label: this.$t("Hours") },
        { value: "days", label: this.$t("Days") },
        { value: "weeks", label: this.$t("Weeks") },
        { value: "months", label: this.$t("Months") }
      ]
    }
  },
  watch: {
    values_clone: {
      deep: true,
      handler() {
        this.handleUpdateValues()
      }
    }
  },

  created() {
    this.init()
  },

  methods: {
    setDurationIsoFormat(){
      this.values_clone['duration'] = `P${
            this.values_clone.selected_delay_duration == "days"
              ? `${this.values_clone.selected_duration_value}D`
              : this.values_clone.selected_delay_duration == "hours"
                ? `T${this.values_clone.selected_duration_value}H`
                : this.values_clone.selected_delay_duration == "minutes"
                  ? `T${this.values_clone.selected_duration_value}M`
                  : this.values_clone.selected_delay_duration == "seconds"
                    ? `T${this.values_clone.selected_duration_value}S`
                    : ``
          }`
    },
    handleUpdateValues() {
      let valid_calc = true
      if (!this.values_clone?.selected_delay_duration) {
        valid_calc = false
      }
      if (!this.values_clone?.selected_duration_value) {
        valid_calc = false
      }
      this.setDurationIsoFormat()

      const data = { ...this.values_clone, valid: valid_calc }
      this.$emit("updateValues", data)
    },
    init() {
      this.values_clone = this.$utils.clone(this.selectedNode.data.values)
    }
  }
}
</script>
